<template>
  <el-dialog
    title="操作日志"
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
    class="dialog"
    center
  >
    <div class="changeRecord">
      <div class="table-flex">
        <el-table
          :data="table_list"
          height="100%"
          :border="true"
          :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        >
          <el-table-column prop="create_time" align="center" label="操作时间">
          </el-table-column>
          <el-table-column prop="content" align="center" label="操作事项">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onHandleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "changeRecord",
  props: {},
  components: {},
  data() {
    return {
      dialogVisible: false,

      table_list: [],
      from: {
        page: 1, //	number	页码
        pageSize: 99999999, //number	页大小
        supplier_id: "",
      },
    };
  },
  methods: {
    onInitData(e) {
      this.from.supplier_id = e.supplier.id;

      this.dialogVisible = true;

      this.hqlist();
    },

    hqlist() {
      this.$api.payment.stafflog(this.from).then((res) => {
        this.table_list = res.data.data;
      });
    },
    onHandleClose() {
      this.dialogVisible = false;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.changeRecord {
  padding: 20px;
  box-sizing: border-box;
  height: 500px;
  display: flex;
  flex-direction: column;
  .table-flex {
    flex: 1;
  }
  .title-from {
    margin-bottom: 20px;
  }
}
</style>
